import { MonitoringContext } from 'context/monitoring';
import { useContextSelector } from 'use-context-selector';

export function useFencesSelectedInfo() {
  const fencesSelected = useContextSelector(
    MonitoringContext,
    context => context.fencesSelected
  );

  return {
    fencesSelected,
  };
}

